import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Area } from './../../modelos/area';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-editar-area',
    templateUrl: './editar-area.component.html',
    styleUrls: ['./editar-area.component.css']
})
export class EditarAreaComponent implements OnInit {

    @Input() area: Area;

    @Input() index: number;

    @Output() areaEvent: EventEmitter<Area>;

    public areaCopy: Area;

    constructor (private modalService: NgbModal) {
        this.areaEvent = new EventEmitter<Area>();
    }

    editar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalTelefone',
            size: 'lg'
        };
        this.areaCopy = new Area(this.area);
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
            this.area = this.areaCopy;
            this.areaCopy.index = this.index;
            this.areaEvent.emit(this.areaCopy);
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/editar-area/editar-area.component.ts